<template>
    <div class="base-forget-pwd" :class="{'forgetpwd-sp': $store.state.screen == 1}">
        <div class="header">
            <div class="back-img" @click="$router.back()">
                <img class="back" src="~images/back.png" />
            </div>
            <div class="title">找回密码</div>
        </div>
        <div class="content">
            <input class="value" onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}" onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}" type="text" maxlength="11" placeholder="请输入您的手机号" v-model="phone" />
            <div class="val-box">
                <input class="phonecode" type="text" maxlength="6" placeholder="请输入验证码" v-model="code" />
                <div class="code" @click="getCode" v-if="iscode == false">获取验证码</div>
                <div class="code" v-if="iscode == true">{{count}}s</div>
            </div>
            <input class="value pwd" type="text" maxlength="16" placeholder="请设置新密码（6~16位数字或字母）" v-model="newPwd" />
            <input class="value pwd" type="text" maxlength="16" placeholder="请确认新密码" v-model="confirmPwd" />
            <div class="btn-login" @click="submit">确认提交</div>
        </div>
        <transition name="component-fade" mode="out-in">
            <TheTips :msg='msg' v-if="msg" />
        </transition>
    </div>
</template>

<script>
    import TheTips from '@/components/TheTips'

    export default {
        name: 'BaseForgetPwd',
        components: {
            TheTips
        },
        data () {
            return {
                msg: null,
                phone: '',
                code: '',
                iscode: false,
                count: 59,
                newPwd: '',
                confirmPwd: '',
                loginData: {}
            }
        },
        methods: {
            onBack () {
                this.$router.push('/base-login?delstatus=' + 1+'&isHasBox='+this.loginData.isHasBox)
            },
            // 获取验证码
            getCode () {
                if (this.iscode == true) {
                    return false
                }
                if (!this.phone.replace(/\s*/g, "")) {
                    return false
                }
                let reg = /^1[0-9]{10}$/
                if (this.phone.length == 11 && reg.test(this.phone)) {
                    let options = {
                        appid: this.loginData.appid, //应用ID
                        mobile: this.phone,
                        type: 4 //1 注册 2绑定 3解绑 4 找回密码
                    };
                    options.sign = this.util.getSign(options, this.loginData.appkey);
                    this.$axios.post('https://sdk.gameschain.pro/index.php?g=api&m=user&a=send_message', this.$qs.stringify(options)).then(res => {
                        if (res.data.status == 1) {
                            this.iscode = true
                            this.count = 59
                            let time = setInterval(() => {
                                this.count--
                                if (this.count == 0) {
                                    clearInterval(time)
                                    this.iscode = false
                                }
                            }, 1000)

                            this.msg = '验证码已发送'
                            setTimeout(() => {
                                this.msg = null
                            }, 1000)
                        } else {
                            this.msg = res.data.msg
                            setTimeout(() => {
                                this.msg = null
                            }, 2000)
                        }
                    }).
                    catch(o => {
                        this.msg = '请求失败'
                        setTimeout(() => {
                            this.msg = null
                        }, 2000)
                    })
                } else {
                    this.msg = '手机号格式不正确'
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                }
            },
            // 找回密码
            submit () {
                let reg = /^1[0-9]{10}$/
                if (!reg.test(this.phone)) {
                    this.msg = '手机号格式不正确'
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                    return false
                }
                if (!this.code.replace(/\s*/g, "")) {
                    this.msg = '请输入验证码'
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                    return false
                }
                if (this.newPwd.replace(/\s*/g, "") || this.confirmPwd.replace(/\s*/g, "")) {
                    if (this.newPwd.replace(/\s*/g, "").length >= 6 || this.confirmPwd.replace(/\s*/g, "").length >= 6) {
                        if (this.newPwd.replace(/\s*/g, "") == this.confirmPwd.replace(/\s*/g, "")) {
                            let options = {
                                mobile: this.phone,
                                code: this.code,
                                password: this.newPwd,
                                appid: this.loginData.appid
                            }
                            options.sign = this.util.getSign(options, this.loginData.appkey)
                            this.$axios.post('https://sdk.gameschain.pro/index.php?g=api&m=user&a=forget_password_by_mobile',this.$qs.stringify(options)).then(res => {
                                if (res.data.status == 1) {
                                    this.msg = '提交成功'
                                    setTimeout(() => {
                                        this.msg = null
                                        this.onBack()
                                    }, 1000)
                                } else {
                                    this.msg = res.data.msg
                                    setTimeout(() => {
                                        this.msg = null
                                    }, 2000)
                                }
                            }).
                            catch(o => {
                                this.msg = '请求失败'
                                setTimeout(() => {
                                    this.msg = null
                                }, 2000)
                            })
                        } else {
                            this.msg = '两次密码输入不一致'
                            setTimeout(() => {
                                this.msg = null
                            }, 2000)
                        }
                    } else {
                        this.msg = '密码长度为6到16位'
                        setTimeout(() => {
                            this.msg = null
                        }, 2000)
                    }
                }
            }
        },
        created () {
            this.loginData = JSON.parse(sessionStorage.getItem('loginData'))
        }
    }
</script>

<style lang="scss" scoped>
    $color: #FF6C22; // 主体颜色
    // 横屏css
    .base-forget-pwd {
        width: 864px;
        min-height: 888px;
        overflow: hidden;
        border-radius: 18px;
        background: rgba(0, 0, 0, 0.8);
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        transition: all 0.3s;
        .header {
            height: 132px;
            background: rgba($color, 0.8);
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            .back-img {
                width: 192px;
                height: 132px;
                position: absolute;
                left: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                .back {
                    width: 72px;
                    height: 72px;
                }
            }
            .title {
                font-size: 51px;
                text-align: center;
            }
        }
        .content {
            min-height: 756px;
            padding: 0 60px 60px;
            overflow: hidden;
            .value {
                width: 100%;
                height: 120px;
                color: #fff;
                font-size: 39px;
                border: 0;
                border-radius: 18px;
                background: rgba(255, 255, 255, 0.2);
                padding: 0 45px;
                margin: 60px 0 30px;
                outline: none;
            }
            .pwd {
                margin: 30px 0 0;
            }
            .val-box {
                width: 100%;
                height: 120px;
                color: #fff;
                border-radius: 18px;
                background: rgba(255, 255, 255, 0.2);
                display: flex;
                align-items: center;
                .phonecode {
                    width: 477px;
                    height: 48px;
                    color: #fff;
                    font-size: 39px;
                    border: 0;
                    border-right: 3px solid $color;
                    border-radius: 18px 0 0 18px;
                    background: transparent;
                    padding: 0 45px;
                    outline: none;
                }
                .code {
                    flex: 1;
                    color: $color;
                    font-size: 36px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }
            input::-webkit-input-placeholder{
                color:rgba(255, 255, 255, 0.5);
            }
            input::-moz-input-placeholder{
                color:rgba(255, 255, 255, 0.5);
            }
            input::-ms-input-placeholder{
                color:rgba(255, 255, 255, 0.5);
            }
            input::-o-input-placeholder{
                color:rgba(255, 255, 255, 0.5);
            }
            .btn-login {
                height: 120px;
                font-size: 39px;
                border-radius: 18px;
                background: $color;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 30px;
            }
        }
    }
    // 竖屏css
    .forgetpwd-sp {
        width: 1570px;
        min-height: 1614px;
        border-radius: 32px;
        .header {
            height: 240px;
            .back-img {
                width: 290px;
                height: 240px;
                .back {
                    width: 130px;
                    height: 130px;
                }
            }
            .title {
                font-size: 92px;
            }
        }
        .content {
            min-height: 1374px;
            padding: 0 90px 90px;
            .value {
                height: 200px;
                font-size: 70px;
                border-radius: 32px;
                padding: 0 81px;
                margin: 90px 0 54px;
            }
            .pwd {
                margin: 54px 0 0;
            }
            .val-box {
                height: 200px;
                border-radius: 32px;
                .phonecode {
                    width: 867px;
                    height: 87px;
                    font-size: 70px;
                    border-right: 5px solid $color;
                    border-radius: 32px 0 0 32px;
                    padding: 0 81px;
                }
                .code {
                    font-size: 65px;
                }
            }
            .btn-login {
                height: 200px;
                font-size: 70px;
                border-radius: 32px;
                margin-top: 54px;
            }
        }
    }
</style>